exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2_cGsdVtaRDAVz{display:flex;justify-content:center}._38xsYmJ6Fg7-MB{max-width:640px}", ""]);

// exports
exports.locals = {
	"container": "_2_cGsdVtaRDAVz",
	"content": "_38xsYmJ6Fg7-MB"
};